import type { ComponentProps } from "react";
import { useSubjectNames } from "../../../../../hooks/useSubjectNames";
import { CorpusFeedCompositionView } from "../../../../../lib/corpusFeedCompositionView";
import { FeedComposition } from "./FeedComposition";

type CompositionProps = Omit<ComponentProps<typeof FeedComposition>, "subjectNames">;

interface NamedCompositionProps extends CompositionProps {
  subjects: string[];
}

function NamedComposition({ subjects, ...props }: NamedCompositionProps) {
  const subjectNames = useSubjectNames(subjects);
  return <FeedComposition {...props} subjectNames={subjectNames} />;
}

/** The composition panel with the names of its subjects, looked up once the composition has
 *  loaded and again whenever its subjects change. */
export function FeedCompositionWithSubjectNames(props: CompositionProps) {
  const subjects = props.composition.data
    ? new CorpusFeedCompositionView(props.composition.data).subjectIds
    : [];
  // Keyed by the subjects, so a new list of them looks its names up afresh.
  return <NamedComposition key={subjects.join(",")} subjects={subjects} {...props} />;
}
